module.exports = __webpack_public_path__ + "static/media/new_logo.bcd54565.png";